"use client"

import { I18nextProvider } from "react-i18next"
import initTranslations from "@i18n"
import { createInstance } from "i18next"
import { useMemo } from "react"

export default function TranslationsProvider({
  children,
  locale,
  namespaces,
  resources
}) {
  const i18n = useMemo(() => {
    const instance = createInstance()
    initTranslations(locale, namespaces, instance, resources)
    return instance
  }, [locale, namespaces, resources])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
